import { ReactNode } from 'react';
import FeatureRolloutContext from '../../context/FeatureRolloutContext';
import { useFeatureRolloutData } from '../../hooks/useFeatureRolloutData';

interface FeatureRolloutProviderProps {
    children: ReactNode | ((params: { hasFeature: (name: string) => boolean }) => ReactNode);
}
const FeatureRolloutProvider = (props: FeatureRolloutProviderProps) => {
    const { children } = props;

    const featureRolloutData = useFeatureRolloutData();

    return (
        <FeatureRolloutContext.Provider value={{ hasFeature: featureRolloutData.hasFeature }}>
            {typeof children === 'function' ? children({ hasFeature: featureRolloutData.hasFeature }) : children}
        </FeatureRolloutContext.Provider>
    );
};

export default FeatureRolloutProvider;
